import scrollToElem from "../helpers/scroll-to";

const checkSiteHeaderAndScroll = (getDestEl, destName, nestedFaq) => {
  const siteHeaderHeight = window.siteHeaderHeight;
  let additionalOffset = 0;
  if (nestedFaq) {
    const getFirstAnchorY = getDestEl.querySelectorAll("a[id], a[name]")[0].getBoundingClientRect().top;
    additionalOffset = getFirstAnchorY - getDestEl.getBoundingClientRect().top + 1;
    console.log("wpro_debug__additionalOffset__object")
    console.log({wpro_debug__additionalOffset__object: siteHeaderHeight + additionalOffset})
  }
  scrollToElem(getDestEl, siteHeaderHeight + additionalOffset, destName);
  window.addEventListener("scrollend", () => {
    return history.pushState(null, null, "#" + destName);
  });
  return false;
};
const scrollPageTo = (destName) => {
  const destEls = document.querySelector(`a[name="${destName}"]`)
    ? document.querySelector(`a[name="${destName}"]`)
    : document.getElementById(destName);
  if (destEls) {
    const getAccordionItem = destEls.closest(".acc-item");
    const getDestElSection = destEls.closest(".section");
    if (getAccordionItem) {
      const isNested = getAccordionItem.closest(".nested-faqs");
      checkSiteHeaderAndScroll(getAccordionItem, destName, isNested);
      return;
    } else if (getDestElSection) {
      if(getAccordionItem){
        const getAccordionQuestionGap = (destEls.getBoundingClientRect().top - getAccordionItem.getBoundingClientRect().top);
        if(getAccordionQuestionGap > 0) {
          destEls.style.scrollMarginTop = `${getAccordionQuestionGap}px`;
        }
      }
      checkSiteHeaderAndScroll(getDestElSection, destName);
      return;
    }
  }
  return;
};

if (window.location.hash) {
  window.scrollTo(0, 0);
  setTimeout(()  => {
    window.scrollTo(0, 0);
    const destName = window.location.hash.substring(1);
    if (destName) {
      scrollPageTo(destName);
    }
  }, 50);
}

const anchorEls = document.querySelectorAll(
  '.section:not(.section--faqaccordion) a[href*="#"]'
);
anchorEls.forEach((anchorEl) => {
  anchorEl.addEventListener("click", (e) => {
    e.preventDefault();
    const destName = anchorEl.getAttribute("href").split("#")[1];
    const anchorElementExist = document.querySelectorAll(`a[name="${destName}"], a[id="${destName}"]`).length > 0;
    if(anchorElementExist){
      if (destName) {
        scrollPageTo(destName);
        return;
      }
    }else{
      if(e.target.href){
        window.location = e.target.href;
      }else{
        console.log(`wpro_debug__Anchor Link Error:: No href found for ${anchorEl}`);
        return;
      }
    }
  });
});

export { scrollPageTo };